module.exports = __webpack_public_path__ + "static/img/level-card-banner1.1c47b10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/5/level-card-banner1.png
// module id = Ndw3
// module chunks = 1